import { Box, Breadcrumbs, Button, Divider, Link, Typography } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import ContentWrapper from "../components/ContentWrapper";
import PageHeading from "../components/PageHeading";
import SaveList from "../components/SaveList";
import allRoutes from "../constants/routes";
import { initialState, setValues } from "../store/slices/spectrumPricing";

const SpectrumPricing: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const startSearch = () => {
    dispatch(setValues(initialState));

    navigate(`${allRoutes.spectrum_pricing.path}/search`);
  };

  return (
    <>
      <Helmet title="Spectrum Pricing - GSA GAMBoD" />
      <PageHeading title={allRoutes.spectrum_pricing.label} icon={allRoutes.spectrum_pricing.icon} color={allRoutes.spectrum_pricing.color} section="spectrum_pricing">
        <Breadcrumbs>
          <Link href={allRoutes.dashboard.path}>Dashboard</Link>
          <Typography>Spectrum Pricing</Typography>
        </Breadcrumbs>
      </PageHeading>
      <ContentWrapper body inset>
        <Box marginY={16} maxWidth={640}>
          <Typography variant="subtitle1">
            Access comprehensive data on spectrum pricing across different regions and technologies. Analyze pricing trends and compare costs across different markets.<br /><br />
            Please note this is a beta release and includes data from 2022 onwards. We will add more data soon.
          </Typography>
        </Box>
        <Box marginY={16}>
          {/* @ts-ignore */}
          <Button variant="contained" color="spectrum_pricing" sx={{ color: "white" }} onClick={startSearch} data-testid="searchButton">
            Start New Search
          </Button>
        </Box>
      </ContentWrapper>
      <Divider />
      <SaveList sectionId={7} />
    </>
  );
};

export default SpectrumPricing; 